import ModalGallery from './ModalGallery';

export default ModalGallery;
